import React, {Fragment} from 'react';

import {withRouter} from "react-router-dom";


const BaseTemplateLogin = (props) => {
    return (

            <div className='w-100'>
                <div className="mt-32">
                    {
                        props.children
                    }
                </div>
            </div>

    )

};

export default withRouter(BaseTemplateLogin);
